import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExportDeclarationGetsPortalRequest } from 'src/app/core/models/transport-operation/gets-exportDeclaration-request';
import { ExportDeclarationGetsPortalResponse } from 'src/app/core/models/transport-operation/gets-exportDeclaration-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(
    private http: HttpClient
  ) { }

  /**
   * query export By UI condition
   * @param params
   */
  queryExport(params: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/exportHeader`;
    return this.http.post(url, params);
  }

  /**
   * get export detail nby export No
   * @param exportDeclarationNo export No
   */
  getExportDetail(exportDeclarationNo: string): Promise<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/${exportDeclarationNo}`;
    return this.http.get(url).toPromise();
  }

  /**
   * get Export Header By ExportDeclarationNo
   * @param exportDeclarationNo export no
   */
  getExportHeader(exportDeclarationNo: string): Promise<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/header/${exportDeclarationNo}`;
    return this.http.get(url).toPromise();
  }

  /**
   * update export
   */
  updateExport(updateObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration`;
    return this.http.put(url, updateObj);
  }

  /**
   * add Export
   */
  addExport(saveObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration`;
    return this.http.post(url, saveObj);
  }

  /**
   * query Import Dos
   * @param exportDeclarationNo
   * @param startDate
   * @param endDate
   * @returns
   */
  queryImportDos(exportDeclarationNo: string, startDate: string, endDate: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/query/exportDeclaration/${exportDeclarationNo}/${encodeURIComponent(startDate)}/${encodeURIComponent(endDate)}`;
    return this.http.get(url);
  }

  /**
   * import Export Detail
   * @param importObj
   * @returns
   */
  importExportDetail(importObj: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/exportDetail`;
    return this.http.post(url, importObj);
  }

  /**
   * can export or not
   * @param exportDeclarationNo exportDeclaration No.
   * @returns
   */
  checkExport(exportDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/check/exportDeclaration/${exportDeclarationNo}`;
    return this.http.get(url);
  }

  /**
   * check success and export
   * @param exportDeclarationNo exportDeclaration No.
   * @returns
   */
  finalExport(exportDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/add/exportDeclaration/${exportDeclarationNo}`;
    return this.http.get(url);
  }

  /**
   * delete export
   * @param exportDeclarationNo exportDeclaration No.
   * @returns
   */
  deleteExport(exportDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/delete/exportDeclaration/${exportDeclarationNo}`;
    return this.http.get(url);
  }

  /**
   * delete export detail
   * @param exportDeclarationNo exportDeclaration No.
   * @param doNo do No.
   * @returns
   */
  deleteExportDetail(exportDeclarationNo: string, doNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/exportDeclarationDetail/${exportDeclarationNo}/${doNo}`;
    return this.http.delete(url);
  }

  /**
   * get Consignee Options
   * @returns Consignee Options
   */
  getCustomerOption(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/Customer/Options`;
    return this.http.get(url);
  }

  deleteExportHeader(exportDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/delete/exportDeclarationHeader/${exportDeclarationNo}`;
    return this.http.get(url);
  }
  saveBillingBy(exportDeclarationNo: string): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/saveBillingBy/${exportDeclarationNo}`;
    return this.http.post(url, null);
  }

  queryImportHKDos(exportDeclarationNo: string, doNos: string[]): Observable<any>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/query/exportDeclarationWithoutErp/${exportDeclarationNo}`;
    return this.http.post(url, doNos);
  }

  callGets(request: ExportDeclarationGetsPortalRequest): Observable<ExportDeclarationGetsPortalResponse>{
    const url = `${environment.logisticsApiUrl}/exportDeclaration/callGets`;
    return this.http.post<ExportDeclarationGetsPortalResponse>(url, request);
  }
}
